const CORE_STATUS = Object.freeze({
    CREATED : 'CREATED',
    STAGED : 'STAGED',
    COMPLETED : 'COMPLETED',
    UNDERWRITING: 'UNDERWRITING'
});

export default CORE_STATUS;